import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { GridCellParams } from '@mui/x-data-grid';
import { WhiteTooltip } from '@AMIEWEB/Common';

const StyledTootltip = makeStyles()((theme: Theme) => ({
  truncation: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export const CustomTooltipCellRenderer = React.memo(function CustomTooltipCellRenderer(cellParams: any) {
  const { classes } = StyledTootltip();

  return (
    <WhiteTooltip
      arrow={false}
      title={cellParams?.row?.facilityApprovedBy?.length > 25 ? cellParams?.row?.facilityApprovedBy : ''}
    >
      <div className={classes.truncation}>
        {cellParams?.row?.facilityApprovedBy ? cellParams?.row?.facilityApprovedBy : '--'}
      </div>
    </WhiteTooltip>
  );
});

export const TimeOffToolTip = (params: GridCellParams) => {
  return <CustomTooltipCellRenderer {...params} />;
};
